class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    const debouncedOnResize = debounce(() => {
      this.onResize();
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
    this.addEventListener("resize", debouncedOnResize.bind(this));

    this.onResize();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (
      event.target.step &&
      !isNaN(parseInt(event.target.step)) &&
      inputValue % parseInt(event.target.step) !== 0
    ) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onResize() {
    const cartFooter = document.querySelector(".cart__footer");
    const cartPage = document.querySelector(".cart-page");
    if (cartFooter && cartPage) {
      // Check window width
      if (window.innerWidth < 750) {
        // Remove min-height if it exists
        cartPage.style.minHeight = "";
      } else {
        // Add a min-height style to the cartPage with the height of the footer
        cartPage.style.minHeight = `${cartFooter.offsetHeight + 120}px`;
      }
    }
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          // Get the new cart-drawer to check if it's empty or not
          const newCartDrawer = html.querySelector("cart-drawer");
          const currentCartDrawer = document.querySelector("cart-drawer");

          // Update the cart-drawer's empty state classes
          if (newCartDrawer && currentCartDrawer) {
            if (newCartDrawer.classList.contains("is-empty")) {
              currentCartDrawer.classList.add("is-empty");
            } else {
              currentCartDrawer.classList.remove("is-empty");
            }
          }

          // Also update the cart-drawer-items empty state
          const newCartDrawerItems = html.querySelector("cart-drawer-items");
          const currentCartDrawerItems =
            document.querySelector("cart-drawer-items");

          if (newCartDrawerItems && currentCartDrawerItems) {
            if (newCartDrawerItems.classList.contains("is-empty")) {
              currentCartDrawerItems.classList.add("is-empty");
            } else {
              currentCartDrawerItems.classList.remove("is-empty");
            }
          }

          // Update the drawer inner content (handles empty vs non-empty content structure)
          const newDrawerInner = html.querySelector(".drawer__inner");
          const currentDrawerInner = document.querySelector(".drawer__inner");

          if (newDrawerInner && currentDrawerInner) {
            currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
          }

          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });

      // Separately fetch and update the cart icon bubble
      fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          // The cart-icon-bubble section contains the content that should go inside #cart-icon-bubble
          const sectionContent = html.querySelector(".shopify-section");
          const currentCartIconBubble =
            document.querySelector("#cart-icon-bubble");

          if (sectionContent && currentCartIconBubble) {
            currentCartIconBubble.innerHTML = sectionContent.innerHTML;
          }
        })
        .catch((e) => {
          console.error("Error updating cart icon bubble:", e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "empty-cart-image-wrapper",
        section: "empty-cart-image-wrapper",
        selector: ".js-contents",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".cart__ctas",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          quantityElement &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch((e) => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        console.log("Caught error updating quantity", e);
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (html === null) {
      return "";
    }
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Cart Promotional Code Handler
if (!customElements.get("cart-promo-code")) {
  customElements.define(
    "cart-promo-code",
    class CartPromoCode extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.setupEventListeners();
      }

      setupEventListeners() {
        const promoInput = document.getElementById("promo-code-input");
        const applyButton = document.getElementById("apply-promo-code");

        if (!promoInput || !applyButton) return;

        // Enable/disable apply button based on input
        promoInput.addEventListener("input", (e) => {
          const hasValue = e.target.value.trim().length > 0;
          applyButton.disabled = !hasValue;
        });

        // Handle apply button click
        applyButton.addEventListener("click", () => {
          this.applyPromoCode();
        });

        // Handle Enter key press
        promoInput.addEventListener("keypress", (e) => {
          if (e.key === "Enter" && !applyButton.disabled) {
            e.preventDefault();
            this.applyPromoCode();
          }
        });

        // Handle remove discount buttons
        const removeButtons = document.querySelectorAll(
          ".remove-discount-button"
        );
        removeButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            const discountCode = button.dataset.discountCode;
            this.removeDiscountCode(discountCode);
          });
        });

        // Handle cart form submission to include discount codes
        const cartForm = document.getElementById("cart");
        if (cartForm) {
          cartForm.addEventListener("submit", (e) => {
            e.preventDefault();
            this.handleCheckout();
          });
        }
      }

      applyPromoCode() {
        const promoInput = document.getElementById("promo-code-input");
        const applyButton = document.getElementById("apply-promo-code");
        const messageElement = document.getElementById("promo-code-message");

        if (!promoInput || !applyButton || !messageElement) return;

        const code = promoInput.value.trim();
        if (!code) return;

        // Show loading state
        this.showMessage("loading", "Application du code en cours...");
        applyButton.disabled = true;

        // Use Shopify's cart update endpoint with discount code
        const formData = new FormData();
        formData.append("discount", code);

        fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: new URLSearchParams(formData),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            // Check if the cart was updated successfully
            if (
              data &&
              (data.token || data.items || data.item_count !== undefined)
            ) {
              this.showMessage(
                "success",
                "Code promotionnel appliqué avec succès!"
              );
              // Trigger cart update to refresh all sections
              this.updateCartSections();
            } else {
              this.showMessage("error", "Code promotionnel invalide");
            }
          })
          .catch((error) => {
            console.error("Error applying promo code:", error);

            // Handle specific Shopify error responses
            if (error.message && error.message.includes("422")) {
              this.showMessage("error", "Code promotionnel invalide ou expiré");
            } else if (error.message && error.message.includes("400")) {
              this.showMessage("error", "Code promotionnel non valide");
            } else {
              this.showMessage(
                "error",
                "Erreur lors de l'application du code promotionnel"
              );
            }
          })
          .finally(() => {
            applyButton.disabled = false;
          });
      }

      removeDiscountCode(discountCode) {
        // Use Shopify's cart update endpoint to remove discount code
        const formData = new FormData();
        formData.append("discount", "");

        fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: new URLSearchParams(formData),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            // Check if the cart was updated successfully
            if (
              data &&
              (data.token || data.items || data.item_count !== undefined)
            ) {
              this.showMessage("success", "Code promotionnel supprimé");
              // Trigger cart update to refresh all sections
              this.updateCartSections();
            } else {
              this.showMessage(
                "error",
                "Erreur lors de la suppression du code"
              );
            }
          })
          .catch((error) => {
            console.error("Error removing discount code:", error);

            // Handle specific Shopify error responses
            if (error.message && error.message.includes("422")) {
              this.showMessage(
                "error",
                "Erreur lors de la suppression du code"
              );
            } else if (error.message && error.message.includes("400")) {
              this.showMessage("error", "Code promotionnel non trouvé");
            } else {
              this.showMessage(
                "error",
                "Erreur lors de la suppression du code promotionnel"
              );
            }
          });
      }

      showMessage(type, message) {
        const messageElement = document.getElementById("promo-code-message");
        if (!messageElement) return;

        // Remove existing classes
        messageElement.classList.remove("success", "error", "loading");

        // Add new class and show message
        messageElement.classList.add(type);
        messageElement.textContent = message;
        messageElement.style.display = "block";

        // Auto-hide success messages after 5 seconds
        if (type === "success") {
          setTimeout(() => {
            messageElement.style.display = "none";
          }, 5000);
        }
      }

      updateCartSections() {
        // Get the cart items element to use its section rendering logic
        const cartItems = document.querySelector("cart-items");
        if (cartItems) {
          // Use the existing cart update mechanism by calling onCartUpdate
          cartItems.onCartUpdate();

          // Also manually update the cart footer section
          fetch(`${window.Shopify.routes.root}?section_id=main-cart-footer`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const cartFooter = document.getElementById("main-cart-footer");
              const newCartFooter = html.getElementById("main-cart-footer");

              if (cartFooter && newCartFooter) {
                cartFooter.innerHTML = newCartFooter.innerHTML;
                // Re-initialize the promo code handler for the new content
                this.init();

                // Clear the promo code input after successful application
                const promoInput = document.getElementById("promo-code-input");
                if (promoInput) {
                  promoInput.value = "";
                  promoInput.dispatchEvent(new Event("input")); // Trigger input event to update button state
                }
              }
            })
            .catch((error) => {
              console.error("Error updating cart footer:", error);
            });
        }
      }

      handleCheckout() {
        // Get the current cart to check for applied discount codes
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((response) => response.json())
          .then((cart) => {
            const cartForm = document.getElementById("cart");

            // If there are applied discount codes, add them to the form action
            if (
              cart.discount_applications &&
              cart.discount_applications.length > 0
            ) {
              const discountCodes = cart.discount_applications
                .map((discount) => discount.title)
                .join(",");

              // Update the form action to include discount codes
              cartForm.action = `${
                window.Shopify.routes.root
              }checkout?discount=${encodeURIComponent(discountCodes)}`;
            } else {
              // Reset to normal checkout if no discount codes
              cartForm.action = `${window.Shopify.routes.root}checkout`;
            }

            // Submit the form
            cartForm.submit();
          })
          .catch((error) => {
            console.error("Error getting cart for checkout:", error);
            // Fallback to regular form submission if there's an error
            const cartForm = document.getElementById("cart");
            cartForm.submit();
          });
      }
    }
  );
}
